// removed by extract-text-webpack-plugin
module.exports = {"telegramButton":"src-components-TelegramButton-__telegram-module___telegramButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TelegramButton/telegram.module.css
// module id = 1545
// module chunks = 0